<template>
    <custom-modal :size="'max-w-3xl'">
        <template v-slot:maincontent>
            <div class="text-white bg-light-black overflow-y-auto rounded-xl">
                <div class="bg-theme-green flex flex-row justify-between px-4 py-2">
                    <h1 class="text-[24px] font-normal tracking-wider">Item Order</h1>
                    <div class="flex flex-row gap-4 items-center mr-2">
                        <button @click="save" class="bg-white hover:bg-white/[0.8] h-[40px] text-theme-green px-4 rounded">Save</button>
                        <span class="cursor-pointer" @click="closeClick">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.3327 2.54602L17.4527 0.666016L9.99935 8.11935L2.54602 0.666016L0.666016 2.54602L8.11935 9.99935L0.666016 17.4527L2.54602 19.3327L9.99935 11.8793L17.4527 19.3327L19.3327 17.4527L11.8793 9.99935L19.3327 2.54602Z" fill="white"/>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="flex justify-center" v-if="loading">
                    <block-loading  />
                </div>
                <div v-else>
                    <div>
                        <div class="mx-2 mt-4">
                            <div class="text-xs pb-1">Search</div>
                            <div class="flex flex-row items-center bg-theme-modalbg rounded px-4">
                                <svg  width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.9 18.9766L10.325 12.4016C9.825 12.8349 9.24167 13.1724 8.575 13.4141C7.90833 13.6557 7.2 13.7766 6.45 13.7766C4.65 13.7766 3.125 13.1516 1.875 11.9016C0.625 10.6516 0 9.14323 0 7.37656C0 5.6099 0.625 4.10156 1.875 2.85156C3.125 1.60156 4.64167 0.976562 6.425 0.976562C8.19167 0.976562 9.69583 1.60156 10.9375 2.85156C12.1792 4.10156 12.8 5.6099 12.8 7.37656C12.8 8.09323 12.6833 8.7849 12.45 9.45156C12.2167 10.1182 11.8667 10.7432 11.4 11.3266L18 17.8766L16.9 18.9766ZM6.425 12.2766C7.775 12.2766 8.925 11.7974 9.875 10.8391C10.825 9.88073 11.3 8.72656 11.3 7.37656C11.3 6.02656 10.825 4.8724 9.875 3.91406C8.925 2.95573 7.775 2.47656 6.425 2.47656C5.05833 2.47656 3.89583 2.95573 2.9375 3.91406C1.97917 4.8724 1.5 6.02656 1.5 7.37656C1.5 8.72656 1.97917 9.88073 2.9375 10.8391C3.89583 11.7974 5.05833 12.2766 6.425 12.2766Z" fill="#878686"/>
                                </svg>
                                <input v-model="search" type="text" class="w-full focus:ring-0 bg-transparent border-0"  placeholder="Search by Name" />
                            </div>
                        </div>
                        <div class="mx-4 my-6" v-if="filterList.length==0">No product found.</div>
                        <div v-else id="sorting_list" class="flex flex-col overflow-auto my-2 max-h-[calc(100vh_-_250px)]">
                            <div v-for="(each,ind) in filterList" :key="ind" :id="each.id" class="flex flex-row gap-2 items-center mx-6 my-2">
                                <!-- <div @click="moveUp(each)" class="flex justify-center items-center cursor-pointer w-[20px] h-[24px]">
                                    <svg  width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 3.99L3 16L5 16L5 3.99L8 3.99L4 -1.74846e-07L-5.24974e-07 3.99L3 3.99Z" fill="#2BA66B"/>
                                    </svg>
                                </div>
                                <div @click="moveDown(each)" class="flex justify-center items-center cursor-pointer w-[20px] h-[24px]">
                                    <svg class="cursor-pointer" width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 12.01L3 1.31134e-07L5 2.18557e-07L5 12.01L8 12.01L4 16L-5.24974e-07 12.01L3 12.01Z" fill="#2BA66B"/>
                                    </svg>
                                </div> -->
                                <div class="flex justify-center gap-1 items-center cursor-ns-resize w-[24px] h-[24px]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                        <path d="M21 11H3V9H21V11M21 13H3V15H21V13Z" fill="#878686" />
                                    </svg>
                                </div>
                                <span class="w-[24px] h-[24px] rounded" :style="`background-color: ${item.posColour}`"></span>
                                <div class="flex flex-col">
                                    <div class="text-[16px] leading-[20px] font-medium m-0">{{each?.name}}</div>
                                    <div class="text-grey leading[12px] text-[12px] m-0">{{each.brand?.name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        </template>
    </custom-modal>
</template>
<script>
import { defineComponent, ref } from 'vue'
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
import ObjectHelpers from '@/helpers/object';
import BusinessCategoryApis from "@/controllers/BusinessCategoryApis";
import debounce from 'lodash/debounce'
import { mapActions } from "vuex";
import Sortable from 'sortablejs';

export default defineComponent({
    props: ['item'],
    setup() {
        const el = ref(null)
        const sortedObj = ref([])
        const loading = ref(false)
        const snackbar = useSnackbar();
        const productList = ref([])
        const filterList = ref([])
        const search = ref('')

        return {el, sortedObj, snackbar, loading, productList, search , filterList}
    },
    async mounted(){
        await this.getData()
        await this.filterProduct()
        this.draggable()
    },
    watch:{
        search: debounce(async function(val) {
            await this.filterProduct(val)
            this.draggable()
        }, 800)
    },
    methods: {
        draggable(){
            this.el = document.getElementById('sorting_list');
            if(this.el){
                Sortable.create(this.el, {
                    animation: 100,
                    onSort: this.getSortedData
                });
                this.getSortedData()
            }
        },
        getSortedData(){
            this.sortedObj = []
            for(let item of this.el.children){
                this.sortedObj.push({id: parseInt(item.id)})
            }
        },
        async getData(){
            if(!this.item?.id) return

            this.loading = true
            let res = await BusinessCategoryApis.fetchProductsOfCategory(this.item.id, true)
            if(res.status == 200) {
                if(res.data?.payload?.products){
                    this.productList =ObjectHelpers.sort(res.data.payload.products, 'sort')
                }
            }else{
                this.productList = []
            }
        },
        async filterProduct(val){
            if(val){
                this.filterList = [...this.productList.filter(each => each.name.toLowerCase().includes(val.toLowerCase()))]
            }else{
                this.filterList = [...this.productList]
            }
            this.loading = false
        },
        // async moveUp(item){
        //     if(item.sort!=1){
        //         let ind = this.productList.findIndex(each => each.id==item.id)
        //         ObjectHelpers.moveItem(this.productList, ind, (ind-1))
        //         this.productList[ind].sort = (parseInt(item.sort)-1)
        //         this.filterList = [...this.productList]
        //     }
        // },
        // async moveDown(item){
        //     if(item.sort!=this.productList.length){
        //         let ind = this.productList.findIndex(each => each.id==item.id)
        //         ObjectHelpers.moveItem(this.productList, ind, (ind+1))
        //         this.productList[ind].sort = (parseInt(item.sort)+1)
        //         this.filterList = [...this.productList]
        //     }
        // },
        async sortProduct(){
            this.va_spinner(true);
            // let productsOrder = this.productList.map(each => each.id)
            let productsOrder = this.sortedObj.map(each => each.id)
            let res = await BusinessCategoryApis.sortProductsOfCategory({'productIds': productsOrder})
            this.snackbar.add({
                type: 'info',
                text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            this.va_spinner(false);
            this.$emit('close')
        },
        async save(){
            this.sortProduct()
        },
        closeClick(){
            this.$emit('close')
        },
        ...mapActions({
            va_spinner: 'spinner/setSpinner',
        })
    }
})
</script>
